import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import React, { ReactElement, useEffect, useState } from 'react';
import { convertToValidStr } from '../../../../utils/utility';
import { MAX_CHARACTERS_LIMIT } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

export const FormTextInput = (props: any): (ReactElement | null) => {
  const [extraRules, setExtraRules] = useState<any[]>([]);
  const formConfig = useGetFormConfig(props);
  const {
    label, addonBefore, placeholder, disabled, onChange: onChangeFromOrigin, form, key, suffixTestId, required, allowClear,
    regex, onBlur, maxLength = false, maxLengthValue, fieldLengthValue, inputRef, onInput, className, isMaxLengthNotApplicable,
  } = formConfig;

  useEffect((): void => {
    if (disabled) {
      setExtraRules([]);
    }
  }, [disabled]);

  const onChange = (event: any, labelConfig: any): void => {
    const { target: { value } = { value: '' } } = event;
    let validStr = convertToValidStr(value);
    if (regex) {
      validStr = validStr.replace(regex, '');
    }
    if (form) {
      form.setFieldsValue({ [key]: validStr });
    }
    setExtraRules([{
      max: maxLengthValue ? fieldLengthValue?.[0] : !isMaxLengthNotApplicable ? (maxLength || MAX_CHARACTERS_LIMIT) : undefined,
    }]);
    event.target.value = validStr;
    if (onChangeFromOrigin) {
      onChangeFromOrigin(event, labelConfig);
    }
  };

  return <FormItem formConfig={formConfig} extraRules={extraRules}>
    <Input.Password
      type="password"
      iconRender={(visible: any): any => (
        <span style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
          {visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
        </span>
      )}
      allowClear={allowClear}
      data-testid={`${key}${suffixTestId || ''}`}
      prefix={addonBefore}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="new-password"
      onChange={(event: InputProps): void => onChange(event, label)}
      onBlur={onBlur}
      required ={required}
      className={className}
      onInput={onInput}
      ref={inputRef}/>
  </FormItem>;
};

export default FormTextInput;
